import { cva } from 'class-variance-authority'

export type IconProps = {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
}

export const IconVariants = cva('', {
  defaultVariants: {
    size: 'auto',
  },
  variants: {
    size: {
      '2xl': 'h-primitive-40 w-primitive-40',
      auto: '',
      lg: 'h-primitive-24 w-primitive-24',
      md: 'h-primitive-16 w-primitive-16',
      sm: 'h-primitive-12 w-primitive-12',
      xl: 'h-primitive-32 w-primitive-32',
    },
  },
})
